import Vyorelle1 from './Vyorelle.png'
import Vyorelle2 from './Vyorelle.png'





const Vyorelleimages =[
Vyorelle1,Vyorelle2
]

export default Vyorelleimages;